{
	"title": "Impressum",
	"backTitle": "Wstecz",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Niemcy"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Telefaks: +49 6221 481-13553",
			"email": "E-mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Siedziba firmy: Heidelberg",
			"commercialRegister": "Rejestr handlowy: Mannheim, HRB 741878",
			"managingDirectors": "Członkowie zarządu:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
